import { useQuery } from '@tanstack/react-query';
import { getBeneficialOwners } from 'services/portfolios/portfolioService';

const useGetBeneficialOwners = (brUid: string, enable: boolean) => {
  return useQuery({
    queryKey: ['useGetBeneficialOwners', brUid],
    queryFn: () => getBeneficialOwners(brUid),
    enabled: !!brUid && enable,
  });
};

export default useGetBeneficialOwners;
